/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const MoreVerticalStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.3 6.20002C11.8029 6.20002 11.4 5.79708 11.4 5.30002C11.4 4.80297 11.8029 4.40002 12.3 4.40002C12.797 4.40002 13.2 4.80297 13.2 5.30002C13.2 5.79708 12.797 6.20002 12.3 6.20002Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3 12.6C11.8029 12.6 11.4 12.1971 11.4 11.7C11.4 11.203 11.8029 10.8 12.3 10.8C12.797 10.8 13.2 11.203 13.2 11.7C13.2 12.1971 12.797 12.6 12.3 12.6Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4 18.1C11.4 18.5971 11.8029 19 12.3 19C12.797 19 13.2 18.5971 13.2 18.1C13.2 17.603 12.797 17.2 12.3 17.2C11.8029 17.2 11.4 17.603 11.4 18.1Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { MoreVerticalStrokeIcon };
